import { render, staticRenderFns } from "./ProcessList.vue?vue&type=template&id=8874c2fc&scoped=true&lang=html&"
import script from "./ProcessList.vue?vue&type=script&lang=js&"
export * from "./ProcessList.vue?vue&type=script&lang=js&"
import style0 from "./ProcessList.vue?vue&type=style&index=0&id=8874c2fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8874c2fc",
  null
  
)

export default component.exports